export default __webpack_public_path__ + "static/media/template7.4f058c0c.jpg";